module.exports = __webpack_public_path__ + "static/media/0.a42cd359.jpg";